<template>
    <div class="make">
        <ul class="makeUl">
            <li class="item" v-for="(item, index) in listOrder" :key="index">
                <div class="title">{{item.activityName}}</div>
                <div>预约品牌{{item.brandName}}</div>
                <div>活动标题有效体质：{{item.startTime - item.endTime}}</div>
                <div>预约日期：{{item.appointmentTime}}</div>
            </li>
        </ul>
    </div>
</template>
<script>
import { listOrderContract } from '@/api/index';
export default {
    data(){
        return {
            listOrder:[]
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            let data = this.$loca.getItem('phone');
            listOrderContract({appointmentPhone: data}).then(res=>{
                this.listOrder = res.data;
            }).catch( error=> {
                console.log('获取预约列表 views/make/index.vue')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.make{
    width: 100vw;
    height: 100%;
    background: #f6f6f6;
    .item{
        background: #ffffff;
        padding: 20px 0;
        margin-bottom: 20px;
        .title{
            padding-bottom:20px;
            border-bottom: 2px solid rgba(230,230,230,1);
        }
        div{
            margin: 0 20px;
            margin-bottom: 20px;
        }
    }
}
</style>

